module.exports = __webpack_public_path__ + "static/img/tech2.51824347.png";